import { render, staticRenderFns } from "./ManterTurnosView.vue?vue&type=template&id=736422ff"
import script from "./ManterTurnosView.vue?vue&type=script&lang=js"
export * from "./ManterTurnosView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports